<template>
  <v-flex mt-4 main-section>
    <!-- <v-card-title>
        <h3 class="halfwhite-text">
          {{ $store.getters.getHeadingForBalanceBlock }}
        </h3>
        <h3 class="title halfwhite-text text-uppercase">Your Ovations</h3>
      </v-card-title> -->
    <v-layout row wrap>
      <v-flex xs12>
        <!-- <v-card class="rounded"> -->
        <!-- <v-card-title>
              <v-flex text-xs-center>
                <span class="headline grey--text">Your Ovations</span>
              </v-flex>
            </v-card-title> -->
        <!-- FUNDS BALANCE -->

        <!-- Redeem or Share -->
        <v-flex mt-3>
          <OvationsPoints></OvationsPoints>
        </v-flex>

        <!-- ** Only Show if Org Owner or SuperAdmin ** -->
        <v-flex
          mt-3
          v-if="
            $store.getters.userIsAdministrativeOrOrgOwner &&
            !$store.getters.isCurrentOrgChild
          "
        >
          <BalanceBlock
            :config="{
              floatBgColor: $store.state.colorScheme.funds.gOvations.base,
              floatTextColor: $store.state.colorScheme.funds.gOvations.accent,
              floatIcon: 'mdi-coins',
              balanceName: 'Distribute Ovations',
              balanceAmount: $store.state.userSelf.currentOrg.root,
              actionIcon: 'mdi-coins',
              actionText: 'DISTRIBUTE',
              actionTextZeroBalance: 'NO OVATIONS TO DISTRIBUTE',
              actionLink: '/assignovations',
              target: '',
              actionZeroBalanceLink: '/buyovations',
              btnClass: 'red-btn',
              textClass: 'display-1 red-text font-weight-bold',
              inAppLink: true,
              btnColor: '#d13b55',
            }"
          ></BalanceBlock>
        </v-flex>

        <!-- GIVE OVATIONS BALANCE -->
        <v-flex mt-3>
          <BalanceBlock
            :config="{
              floatBgColor: $store.state.colorScheme.funds.dollars.base,
              floatTextColor: $store.state.colorScheme.funds.dollars.accent,
              floatIcon: 'mdi-coins',
              balanceName: 'Send Ovations',
              balanceAmount: $store.state.userSelf.currentOrg.giveOvations,
              actionIcon: 'mdi-coins',
              actionText: 'SEND',
              actionTextZeroBalance: 'NO OVATIONS TO SEND',
              actionLink: '/giveovations',
              target: '',
              actionZeroBalanceLink: '/dashboard',
              btnClass: 'blue-btn',
              textClass: 'display-1 blue-text font-weight-bold',
              inAppLink: true,
              btnColor: '#3cc0c9',
            }"
          ></BalanceBlock>
        </v-flex>

        <!-- SPENDABLE OVATIONS BALANCE -->
        <!-- <v-flex pb-3>
            <BalanceBlock
              :config="{
                floatBgColor: $store.state.colorScheme.funds.sOvations.base,
                floatTextColor: $store.state.colorScheme.funds.sOvations.accent,
                floatIcon: 'mdi-coins',
                balanceName: 'Spend Ovations',
                balanceAmount: $store.state.userSelf.currentOrg.spendOvations,
                actionIcon: 'mdi-coins',
                actionText: 'SPEND',
                actionTextZeroBalance: 'NO OVATIONS TO REDEEM',
                actionLink: $store.state.storeUrl,
                target: '_blank',
                actionZeroBalanceLink: '/dashboard',
                btnClass: 'orange-btn',
                textClass: 'display-1 orange-text font-weight-bold',
                inAppLink: false,
                shareSpendOvations: $store.getters.shareSpendOvations,
                shareIcon: 'mdi-share',
                shareLink: '/shareovations',
                shareTarget: '',
                shareText: 'SHARE',
                btnColor: '#e0922f',
              }"
            ></BalanceBlock>
          </v-flex> -->

        <!-- </v-card> -->
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import BalanceBlock from "@/components/BalanceBlock";
import OvationsPoints from "@/components/OvationsPoints";

export default {
  name: "BalanceColumn",
  components: {
    BalanceBlock,
    OvationsPoints,
  },
  data() {
    return {};
  },
};
</script>
